import { Tooltip, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { GoSync } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { completeDailyTask, deleteAllDailyTasks } from "../../../../adapters";
import {
  clearDailyTasksToDelete,
  clearTasksToSync,
  setTasksLastSyncDate,
} from "../../../../config/redux/slices/schedulerSlice";
import {
  selectDailyTasksData,
  selectDailyTasksToDelete,
  selectDailyTasksToSync,
} from "../../../../config/redux/slices/schedulerSlice/selectors";
import { fetchAllDailyTasks } from "../../../../config/redux/slices/schedulerSlice/thunks";
import { formatDateToString } from "../../../../utils/date";
import { showErrors } from "../../../../utils/ui";
import { StyledStreakInfo, StyledSyncIcon } from "./styles";

const StreakInfo = () => {
  const dispatch = useDispatch();
  const [processing, setProcessing] = React.useState(false);

  const dailyTasks = useSelector(selectDailyTasksData);
  const streak = useMemo(
    () => Math.min(...(dailyTasks.data ?? []).map((task) => task.streak)),
    [dailyTasks]
  );

  const tasksToSync = useSelector(selectDailyTasksToSync);
  const tasksToDelete = useSelector(selectDailyTasksToDelete);

  const syncToServer = async () => {
    if (processing) return;
    setProcessing(true);
    if (tasksToSync.length) {
      let finalTasksToSync = structuredClone(tasksToSync);
      if (tasksToDelete.length) {
        finalTasksToSync = finalTasksToSync.filter((task) =>
          tasksToDelete.includes(task)
        );
      }
      if (finalTasksToSync) {
        try {
          await completeDailyTask(finalTasksToSync);
          dispatch(clearTasksToSync());
        } catch (e) {
          showErrors(e);
        }
      }
    }
    if (tasksToDelete.length) {
      try {
        await deleteAllDailyTasks(tasksToDelete);
        dispatch(clearDailyTasksToDelete());
      } catch (e) {
        showErrors(e);
      }
    }
    dispatch(fetchAllDailyTasks());
    dispatch(setTasksLastSyncDate(formatDateToString(new Date())));
    setProcessing(false);
    toast.success("Sync complete");
  };
  return (
    <StyledStreakInfo>
      <Typography>Streak Days: {streak}</Typography>
      <Tooltip title="Sync">
        <StyledSyncIcon $processing={processing}>
          <GoSync onClick={syncToServer} size="24px" />
        </StyledSyncIcon>
      </Tooltip>
    </StyledStreakInfo>
  );
};

export default StreakInfo;
